import { FOOD_SEARCH_PICKER_PAGE_SIZE } from "../../foods/foodSearchService";

export function buildEquivalentOptionPickerResults(
  results = [],
  { limit = FOOD_SEARCH_PICKER_PAGE_SIZE } = {},
) {
  const resolvedResults = Array.isArray(results) ? results : [];
  const resolvedLimit = Math.max(
    1,
    Number(limit) || FOOD_SEARCH_PICKER_PAGE_SIZE,
  );

  return resolvedResults.slice(0, resolvedLimit);
}
